module.exports = __webpack_public_path__ + "img/list-h.5b348c49.svg";